import React, { useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import axios from "axios";
import { useGetSuppliersQuery } from "../../../features/api/supplierApi";
import { useGetProductQuery } from "../../../features/api/productApi";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { API_BASE_URL } from "../../../components/baseUrl";

function DateWisePurchaseReport() {
  // useRef for report
  const componentRef = useRef();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [purchases, setPurchases] = useState([]);

  let sDay = startDate.getDate();
  let sMonth = startDate.getMonth() + 1;
  let sYear = startDate.getFullYear();
  let sGetDate = sDay + "-" + sMonth + "-" + sYear;
  let findStartGetDate = sYear + "-" + sMonth + "-" + sDay;

  let eDay = endDate.getDate();
  let eMonth = endDate.getMonth() + 1;
  let eYear = endDate.getFullYear();
  let eGetDate = eDay + "-" + eMonth + "-" + eYear;
  let findEndGetDate = eYear + "-" + eMonth + "-" + eDay;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/purchaseDate?startDate=${findStartGetDate}&endDate=${findEndGetDate}`
      );

      if (response) {
        setPurchases(response?.data?.purchases);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const suppliers = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const grandTotal = purchases?.reduce((sum, data) => sum + data?.total, 0);
  const totalQuantity = purchases?.reduce((sum, data) => sum + data?.qty, 0);

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div className="px-6 overflow-auto">
      <div>
        <h1 className="font-bold text-xl my-4">Date-wise Purchase Report</h1>
        <div className="bg-white shadow-lg p-4">
          <form
            onSubmit={handleSubmit}
            className="flex justify-between items-center gap-10"
          >
            <div>
              <label className="font-bold">Start Date: </label>

              <DateTimePicker
                value={startDate}
                onChange={setStartDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <div>
              <label className="font-bold">End Date: </label>
              <DateTimePicker
                value={endDate}
                onChange={setEndDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <input
              type="submit"
              value="View"
              className="bg-indigo-500 text-white font-bold px-2 py-1 rounded mt-6 cursor-pointer"
            />
            {purchases?.length > 0 && (
              <ReactToPrint
                trigger={() => (
                  <h1 className="cursor-pointer flex items-center text-red-500 font-bold">
                    <AiFillPrinter /> print
                  </h1>
                )}
                content={() => componentRef.current}
                pageStyle="@page {  margin: 0.5cm; }  }"
              />
            )}
          </form>
        </div>
      </div>
      <div>
        <div ref={componentRef}>
          {purchases?.length > 0 && (
            <div className="">
              <div className="flex flex-col  ">
                <div className="flex justify-center my-2 relative">
                  <div className="text-center mt-2">
                    <h2 className="font-bold text-xl">
                      Johura Endomed Solution
                    </h2>
                    <p>
                      {" "}
                      15/A, Zigatola, Hafizullah Green Tower, Flat # C1
                      Dhanmondi, Dhaka - 1209
                    </p>
                    <p>+88 01711 071102</p>
                  </div>
                </div>
                <div className=" mb-3 pb-3 border-b border-gray-400 ">
                  <p className="text-center font-bold">
                    Purchase Report - Date: {sGetDate} to {eGetDate}
                  </p>
                </div>
                <div>
                  <table className="min-w-full bg-white">
                    <thead>
                      <tr>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Sl No.
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Chalan No.
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Chalan Date
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Supplier
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Product
                        </th>

                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Quantity
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Unit Rate
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          Total Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchases?.map((data, index) => {
                        const suppName = suppliers?.find(
                          (supp) => supp?.id === data?.supp_name
                        );
                        const proName = products?.find(
                          (pro) => pro?.id === data?.pro_name
                        );
                        return (
                          <tr key={index}>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {index + 1}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.ch_no}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {formatDate(data?.ch_date)}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {suppName?.s_name}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {proName?.product_name}
                            </td>

                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.qty}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.unit_price}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.total}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <thead>
                      <tr>
                        <th
                          colSpan={5}
                          className="px-6 py-3 border-b-2 border-gray-300 text-right text-sm font-bold uppercase tracking-wider"
                        >
                          Total Quantity:
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          {totalQuantity}
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-right text-sm font-bold uppercase tracking-wider">
                          Total:
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-sm font-bold uppercase tracking-wider">
                          {grandTotal}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="flex justify-end mt-16">
                  <p className="border-t border-t-black">
                    Authorised Signature
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DateWisePurchaseReport;
